import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";
import { BetSlipContainerProps } from "./types";

export const BetSlipContainer = styled.div<
  Pick<BetSlipContainerProps, "isBetSlipExpanded">
>`
  padding-right: 12px;
  padding-left: 12px;
  transition: padding-left 0.2s linear;

  @media screen and ${breakpoints.desktop.min.xl} {
    padding-left: ${({ isBetSlipExpanded }) =>
      isBetSlipExpanded ? "90px" : "calc(var(--lhn-width, 292px) + 27px)"};
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
  }
`;

const flexCenter = css`
  display: flex;
  align-items: center;
`;

export const BetSlipWrapper = styled.div<{ hasRadiusTop: boolean }>`
  height: 68px;
  ${flexCenter};
  padding: 12px 12px 12px 4px;
  background-color: ${({ theme }) =>
    theme.colorTokens.component.betslip.background};
  box-shadow: 0 1px 16px rgba(17, 43, 68, 0.25);
  position: relative;
  z-index: 900;
  ${({ hasRadiusTop }) =>
    hasRadiusTop
      ? css`
          border-radius: 4px;
        `
      : css`
          border-radius: 0px 0px 4px 4px;
        `}

  @media screen and ${breakpoints.tablet.max.sm} {
    border-radius: 0;
  }
`;

export const LeftColumn = styled.div`
  ${flexCenter};
  flex: 1;
  min-width: 0;
  margin-right: 12px;

  @media screen and ${breakpoints.tablet.max.sm} {
    flex: inherit;
  }
`;

export const RightColumn = styled.div`
  ${flexCenter};
  flex-shrink: 1;
  justify-content: end;

  @media screen and ${breakpoints.tablet.max.sm} {
    flex: 1;

    & > button {
      flex-grow: 1;
    }
  }
`;

export const BetSelectionsContainer = styled.div<{
  numberOfCols: number;
}>`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const ExtendedSelectionsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ScrollContainer = styled.div`
  width: 100%;
  overflow-x: hidden;

  @media screen and ${breakpoints.tablet.max.sm} {
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const ScrollButtonsContainer = styled.div`
  height: 100%;
  padding: 4px 12px;
  display: flex;
  flex-direction: row;
  gap: 12px;

  @media screen and ${breakpoints.tablet.max.sm} {
    display: none;
  }
`;
